module.exports = __webpack_public_path__ + "static/media/gradle_image_presentation.f5a1268c.png";